const gptw = {
  enabled: false,
  companySummary: {
    showLink: false,
  },
}

export default gptw
